import React, { useState } from "react";
import "./styles.css";

const emojiDictionary = {
  "😀": "Smileys and People: Grinning Face",
  "😃": "Smileys and People: Grinning Face with Big Eyes",
  "😄": "Smileys and People: Grinning Face with Smiling Eyes",
  "😁": "Smileys and People: Beaming Face with Smiling Eyes",
  "😆": "Smileys and People: Grinning Squinting Face",
  "😅": "Smileys and People: Grinning Face with Sweat",
  "🤣": "Smileys and People: Rolling on the Floor Laughing",
  "😂": "Smileys and People: Face with Tears of Joy",
  "🙂": "Smileys and People: Slightly Smiling Face",
  "🙃": "Smileys and People: Upside-Down Face",
  "😉": "Smileys and People: Winking Face",
  "😊": "Smileys and People: Smiling Face with Smiling Eyes",
  "😇": "Smileys and People: Smiling Face with Halo",
  "🥰": "Smileys and People: Smiling Face with Hearts",
  "😍": "Smileys and People: Smiling Face with Heart-Eyes",
  "🤩": "Smileys and People: Star-Struck",
  "😘": "Smileys and People: Face Blowing a Kiss",
  "😗": "Smileys and People: Kissing Face",
  "😚": "Smileys and People: Kissing Face with Closed Eyes",
  "😙": "Smileys and People: Kissing Face with Smiling Eyes",
  "😋": "Smileys and People: Face Savoring Food",
  "😛": "Smileys and People: Face with Tongue",
  "😜": "Smileys and People: Winking Face with Tongue",
  "🤪": "Smileys and People: Zany Face",
  "😝": "Smileys and People: Squinting Face with Tongue",
  "🤑": "Smileys and People: Money-Mouth Face",
  "🤗": "Smileys and People: Hugging Face",
  "🤭": "Smileys and People: Face with Hand Over Mouth",
  "🤫": "Smileys and People: Shushing Face",
  "🤔": "Smileys and People: Thinking Face",
  "🤐": "Smileys and People: Zipper-Mouth Face",
  "🤨": "Smileys and People: Face with Raised Eyebrow",
  "😐": "Smileys and People: Neutral Face",
  "😑": "Smileys and People: Expressionless Face",
  "😶": "Smileys and People: Face Without Mouth",
  "😏": "Smileys and People: Smirking Face",
  "😒": "Smileys and People: Unamused Face",
  "🙄": "Smileys and People: Face with Rolling Eyes",
  "😬": "Smileys and People: Grimacing Face",
  "🤥": "Smileys and People: Lying Face",
  "😌": "Smileys and People: Relieved Face",
  "😔": "Smileys and People: Pensive Face",
  "😪": "Smileys and People: Sleepy Face",
  "🤤": "Smileys and People: Drooling Face",
  "😴": "Smileys and People: Sleeping Face",
  "😷": "Smileys and People: Face with Medical Mask",
  "🤒": "Smileys and People: Face with Thermometer",
  "🤕": "Smileys and People: Face with Head-Bandage",
  "🤢": "Smileys and People: Nauseated Face",
  "🤮": "Smileys and People: Face Vomiting",
  "🤧": "Smileys and People: Sneezing Face",
  "🥵": "Smileys and People: Hot Face",
  "🥶": "Smileys and People: Cold Face",
  "🥴": "Smileys and People: Woozy Face",
  "😵": "Smileys and People: Dizzy Face",
  "🤯": "Smileys and People: Exploding Head",
  "🤠": "Smileys and People: Cowboy Hat Face",
  "🥳": "Smileys and People: Partying Face",
  "😎": "Smileys and People: Smiling Face with Sunglasses",
  "🤓": "Smileys and People: Nerd Face",
  "🧐": "Smileys and People: Face with Monocle",
  "😕": "Smileys and People: Confused Face",
  "😟": "Smileys and People: Worried Face",
  "🙁": "Smileys and People: Slightly Frowning Face",
  "☹️": "Smileys and People: Frowning Face",
  "😮": "Smileys and People: Face with Open Mouth",
  "😯": "Smileys and People: Hushed Face",
  "😲": "Smileys and People: Astonished Face",
  "😳": "Smileys and People: Flushed Face",
  "🥺": "Smileys and People: Pleading Face",
  "😦": "Smileys and People: Frowning Face with Open Mouth",
  "😧": "Smileys and People: Anguished Face",
  "😨": "Smileys and People: Fearful Face",
  "😰": "Smileys and People: Anxious Face with Sweat",
  "😥": "Smileys and People: Sad but Relieved Face",
  "😢": "Smileys and People: Crying Face",
  "😭": "Smileys and People: Loudly Crying Face",
  "😱": "Smileys and People: Face Screaming in Fear",
  "😖": "Smileys and People: Confounded Face",
  "😣": "Smileys and People: Persevering Face",
  "😞": "Smileys and People: Disappointed Face",
  "😓": "Smileys and People: Downcast Face with Sweat",
  "😩": "Smileys and People: Weary Face",
  "😫": "Smileys and People: Tired Face",
  "🥱": "Smileys and People: Yawning Face",
  "😤": "Smileys and People: Face with Steam From Nose",
  "😡": "Smileys and People: Pouting Face",
  "😠": "Smileys and People: Angry Face",
  "🤬": "Smileys and People: Face with Symbols on Mouth",
  "😈": "Smileys and People: Smiling Face with Horns",
  "👿": "Smileys and People: Angry Face with Horns",
  "💀": "Smileys and People: Skull",
  "☠️": "Smileys and People: Skull and Crossbones",
  "💩": "Smileys and People: Pile of Poo",
  "🤡": "Smileys and People: Clown Face",
  "👹": "Smileys and People: Ogre",
  "👺": "Smileys and People: Goblin",
  "👻": "Smileys and People: Ghost",
  "👽": "Smileys and People: Alien",
  "👾": "Smileys and People: Alien Monster",
  "🤖": "Smileys and People: Robot",
  "😺": "Smileys and People: Grinning Cat",
  "😸": "Smileys and People: Grinning Cat with Smiling Eyes",
  "😹": "Smileys and People: Cat with Tears of Joy",
  "😻": "Smileys and People: Smiling Cat with Heart-Eyes",
  "😼": "Smileys and People: Cat with Wry Smile",
  "😽": "Smileys and People: Kissing Cat",
  "🙀": "Smileys and People: Weary Cat",
  "😿": "Smileys and People: Crying Cat",
  "😾": "Smileys and People: Pouting Cat",
  "💋": "Smileys and People: Kiss Mark",
  "👋": "Smileys and People: Waving Hand",
  "🤚": "Smileys and People: Raised Back of Hand",
  "🖐️": "Smileys and People: Hand with Fingers Splayed",
  "✋": "Smileys and People: Raised Hand",
  "🖖": "Smileys and People: Vulcan Salute",
  "👌": "Smileys and People: OK Hand",
  "🤏": "Smileys and People: Pinching Hand",
  "✌️": "Smileys and People: Victory Hand",
  "🤞": "Smileys and People: Crossed Fingers",
  "🤟": "Smileys and People: Love-You Gesture",
  "🤘": "Smileys and People: Sign of the Horns",
  "🤙": "Smileys and People: Call Me Hand",
  "👈": "Smileys and People: Backhand Index Pointing Left",
  "👉": "Smileys and People: Backhand Index Pointing Right",
  "👆": "Smileys and People: Backhand Index Pointing Up",
  "🖕": "Smileys and People: Middle Finger",
  "👇": "Smileys and People: Backhand Index Pointing Down",
  "☝️": "Smileys and People: Index Pointing Up",
  "👍": "Smileys and People: Thumbs Up",
  "👎": "Smileys and People: Thumbs Down",
  "✊": "Smileys and People: Raised Fist",
  "👊": "Smileys and People: Oncoming Fist",
  "🤛": "Smileys and People: Left-Facing Fist",
  "🤜": "Smileys and People: Right-Facing Fist",
  "👏": "Smileys and People: Clapping Hands",
  "🙌": "Smileys and People: Raising Hands",
  "👐": "Smileys and People: Open Hands",
  "🤲": "Smileys and People: Palms Up Together",
  "🤝": "Smileys and People: Handshake",
  "🙏": "Smileys and People: Folded Hands",
  "✍️": "Smileys and People: Writing Hand",
  "💅": "Smileys and People: Nail Polish",
  "🤳": "Smileys and People: Selfie",
  "💪": "Smileys and People: Flexed Biceps",
  "🦾": "Smileys and People: Mechanical Arm",
  "🦿": "Smileys and People: Mechanical Leg",
  "🦵": "Smileys and People: Leg",
  "🦶": "Smileys and People: Foot",
  "👂": "Smileys and People: Ear",
  "🦻": "Smileys and People: Ear with Hearing Aid",
  "👃": "Smileys and People: Nose",
  "🧠": "Smileys and People: Brain",
  "🦷": "Smileys and People: Tooth",
  "🦴": "Smileys and People: Bone",
  "👀": "Smileys and People: Eyes",
  "👁️": "Smileys and People: Eye",
  "👅": "Smileys and People: Tongue",
  "👄": "Smileys and People: Mouth",
  "👶": "Smileys and People: Baby",
  "🧒": "Smileys and People: Child",
  "👦": "Smileys and People: Boy",
  "👧": "Smileys and People: Girl",
  "🧑": "Smileys and People: Person",
  "👱": "Smileys and People: Person: Blond Hair",
  "👨": "Smileys and People: Man",
  "🧔": "Smileys and People: Person: Beard",
  "👨‍🦰": "Smileys and People: Man: Red Hair",
  "👨‍🦱": "Smileys and People: Man: Curly Hair",
  "👨‍🦳": "Smileys and People: Man: White Hair",
  "👨‍🦲": "Smileys and People: Man: Bald",
  "👩": "Smileys and People: Woman",
  "👩‍🦰": "Smileys and People: Woman: Red Hair",
  "🧑‍": "Smileys and People: Person: Red Hair",
  "👩‍🦱": "Smileys and People: Woman: Curly Hair",
  "🧑‍": "Smileys and People: Person: Curly Hair",
  "👩‍🦳": "Smileys and People: Woman: White Hair",
  "🧑‍": "Smileys and People: Person: White Hair",
  "👩‍🦲": "Smileys and People: Woman: Bald",
  "🧑‍": "Smileys and People: Person: Bald",
  "👱‍♀️": "Smileys and People: Woman: Blond Hair",
  "👱‍♂️": "Smileys and People: Man: Blond Hair",
  "🧓": "Smileys and People: Older Person",
  "👴": "Smileys and People: Old Man",
  "👵": "Smileys and People: Old Woman",
  "🙍": "Smileys and People: Person Frowning",
  "🙍‍♂️": "Smileys and People: Man Frowning",
  "🙍‍♀️": "Smileys and People: Woman Frowning",
  "🙎": "Smileys and People: Person Pouting",
  "🙎‍♂️": "Smileys and People: Man Pouting",
  "🙎‍♀️": "Smileys and People: Woman Pouting",
  "🙅": "Smileys and People: Person Gesturing No",
  "🙅‍♂️": "Smileys and People: Man Gesturing No",
  "🙅‍♀️": "Smileys and People: Woman Gesturing No",
  "🙆": "Smileys and People: Person Gesturing OK",
  "🙆‍♂️": "Smileys and People: Man Gesturing OK",
  "🙆‍♀️": "Smileys and People: Woman Gesturing OK",
  "💁": "Smileys and People: Person Tipping Hand",
  "💁‍♂️": "Smileys and People: Man Tipping Hand",
  "💁‍♀️": "Smileys and People: Woman Tipping Hand",
  "🙋": "Smileys and People: Person Raising Hand",
  "🙋‍♂️": "Smileys and People: Man Raising Hand",
  "🙋‍♀️": "Smileys and People: Woman Raising Hand",
  "🧏": "Smileys and People: Deaf Person",
  "🧏‍♂️": "Smileys and People: Deaf Man",
  "🧏‍♀️": "Smileys and People: Deaf Woman",
  "🙇": "Smileys and People: Person Bowing",
  "🙇‍♂️": "Smileys and People: Man Bowing",
  "🙇‍♀️": "Smileys and People: Woman Bowing",
  "🤦": "Smileys and People: Person Facepalming",
  "🤦‍♂️": "Smileys and People: Man Facepalming",
  "🤦‍♀️": "Smileys and People: Woman Facepalming",
  "🤷": "Smileys and People: Person Shrugging",
  "🤷‍♂️": "Smileys and People: Man Shrugging",
  "🤷‍♀️": "Smileys and People: Woman Shrugging",
  "👣": "Smileys and People: Footprints",
  "🧳": "Smileys and People: Luggage",
  "🌂": "Smileys and People: Closed Umbrella",
  "☂️": "Smileys and People: Umbrella",
  "🎃": "Smileys and People: Jack-O-Lantern",
  "🧵": "Smileys and People: Thread",
  "🧶": "Smileys and People: Yarn",
  "👓": "Smileys and People: Glasses",
  "🕶️": "Smileys and People: Sunglasses",
  "🥽": "Smileys and People: Goggles",
  "🥼": "Smileys and People: Lab Coat",
  "🦺": "Smileys and People: Safety Vest",
  "👔": "Smileys and People: Necktie",
  "👕": "Smileys and People: T-Shirt",
  "👖": "Smileys and People: Jeans",
  "🧣": "Smileys and People: Scarf",
  "🧤": "Smileys and People: Gloves",
  "🧥": "Smileys and People: Coat",
  "🧦": "Smileys and People: Socks",
  "👗": "Smileys and People: Dress",
  "👘": "Smileys and People: Kimono",
  "🥻": "Smileys and People: Sari",
  "🩱": "Smileys and People: One-Piece Swimsuit",
  "🩲": "Smileys and People: Briefs",
  "🩳": "Smileys and People: Shorts",
  "👙": "Smileys and People: Bikini",
  "👚": "Smileys and People: Woman’s Clothes",
  "👛": "Smileys and People: Purse",
  "👜": "Smileys and People: Handbag",
  "👝": "Smileys and People: Clutch Bag",
  "🎒": "Smileys and People: Backpack",
  "👞": "Smileys and People: Man’s Shoe",
  "👟": "Smileys and People: Running Shoe",
  "🥾": "Smileys and People: Hiking Boot",
  "🥿": "Smileys and People: Flat Shoe",
  "👠": "Smileys and People: High-Heeled Shoe",
  "👡": "Smileys and People: Woman’s Sandal",
  "🩰": "Smileys and People: Ballet Shoes",
  "👢": "Smileys and People: Woman’s Boot",
  "👑": "Smileys and People: Crown",
  "👒": "Smileys and People: Woman’s Hat",
  "🎩": "Smileys and People: Top Hat",
  "🎓": "Smileys and People: Graduation Cap",
  "🧢": "Smileys and People: Billed Cap",
  "⛑️": "Smileys and People: Rescue Worker’s Helmet",
  "💄": "Smileys and People: Lipstick",
  "💍": "Smileys and People: Ring",
  "💼": "Smileys and People: Briefcase",
  "🩸": "Smileys and People: Drop of Blood",
  "🙈": "Smileys and People: See-No-Evil Monkey",
  "🙉": "Smileys and People: Hear-No-Evil Monkey",
  "🙊": "Smileys and People: Speak-No-Evil Monkey",
  "💥": "Smileys and People: Collision",
  "💫": "Smileys and People: Dizzy",
  "💦": "Smileys and People: Sweat Droplets",
  "💨": "Smileys and People: Dashing Away",
  "🐵": "Animal and Nature: Monkey Face",
  "🐒": "Animal and Nature: Monkey",
  "🦍": "Animal and Nature: Gorilla",
  "🦧": "Animal and Nature: Orangutan",
  "🐶": "Animal and Nature: Dog Face",
  "🐕": "Animal and Nature: Dog",
  "🦮": "Animal and Nature: Guide Dog",
  "🐕‍🦺": "Animal and Nature: Service Dog",
  "🐩": "Animal and Nature: Poodle",
  "🐺": "Animal and Nature: Wolf",
  "🦊": "Animal and Nature: Fox",
  "🦝": "Animal and Nature: Raccoon",
  "🐱": "Animal and Nature: Cat Face",
  "🐈": "Animal and Nature: Cat",
  "🦁": "Animal and Nature: Lion",
  "🐯": "Animal and Nature: Tiger Face",
  "🐅": "Animal and Nature: Tiger",
  "🐆": "Animal and Nature: Leopard",
  "🐴": "Animal and Nature: Horse Face",
  "🐎": "Animal and Nature: Horse",
  "🦄": "Animal and Nature: Unicorn",
  "🦓": "Animal and Nature: Zebra",
  "🦌": "Animal and Nature: Deer",
  "🐮": "Animal and Nature: Cow Face",
  "🐂": "Animal and Nature: Ox",
  "🐃": "Animal and Nature: Water Buffalo",
  "🐄": "Animal and Nature: Cow",
  "🐷": "Animal and Nature: Pig Face",
  "🐖": "Animal and Nature: Pig",
  "🐗": "Animal and Nature: Boar",
  "🐽": "Animal and Nature: Pig Nose",
  "🐏": "Animal and Nature: Ram",
  "🐑": "Animal and Nature: Ewe",
  "🐐": "Animal and Nature: Goat",
  "🐪": "Animal and Nature: Camel",
  "🐫": "Animal and Nature: Two-Hump Camel",
  "🦙": "Animal and Nature: Llama",
  "🦒": "Animal and Nature: Giraffe",
  "🐘": "Animal and Nature: Elephant",
  "🦏": "Animal and Nature: Rhinoceros",
  "🦛": "Animal and Nature: Hippopotamus",
  "🐭": "Animal and Nature: Mouse Face",
  "🐁": "Animal and Nature: Mouse",
  "🐀": "Animal and Nature: Rat",
  "🐹": "Animal and Nature: Hamster",
  "🐰": "Animal and Nature: Rabbit Face",
  "🐇": "Animal and Nature: Rabbit",
  "🐿️": "Animal and Nature: Chipmunk",
  "🦔": "Animal and Nature: Hedgehog",
  "🦇": "Animal and Nature: Bat",
  "🐻": "Animal and Nature: Bear",
  "🐨": "Animal and Nature: Koala",
  "🐼": "Animal and Nature: Panda",
  "🦥": "Animal and Nature: Sloth",
  "🦦": "Animal and Nature: Otter",
  "🦨": "Animal and Nature: Skunk",
  "🦘": "Animal and Nature: Kangaroo",
  "🦡": "Animal and Nature: Badger",
  "🐾": "Animal and Nature: Paw Prints",
  "🦃": "Animal and Nature: Turkey",
  "🐔": "Animal and Nature: Chicken",
  "🐓": "Animal and Nature: Rooster",
  "🐣": "Animal and Nature: Hatching Chick",
  "🦠": "Animal and Nature: Microbe",
  "💐": "Animal and Nature: Bouquet",
  "🌸": "Animal and Nature: Cherry Blossom",
  "💮": "Animal and Nature: White Flower",
  "🏵️": "Animal and Nature: Rosette",
  "🌹": "Animal and Nature: Rose",
  "🥀": "Animal and Nature: Wilted Flower",
  "🌺": "Animal and Nature: Hibiscus",
  "🌻": "Animal and Nature: Sunflower",
  "🌼": "Animal and Nature: Blossom",
  "🌷": "Animal and Nature: Tulip",
  "🌱": "Animal and Nature: Seedling",
  "🌲": "Animal and Nature: Evergreen Tree",
  "🧉": "Food and Drink: Mate",
  "🧊": "Food and Drink: Ice",
  "🥢": "Food and Drink: Chopsticks",
  "🍽️": "Food and Drink: Fork and Knife with Plate",
  "🍴": "Food and Drink: Fork and Knife",
  "🥄": "Food and Drink: Spoon",
  "🕴️": "Activity and Sports: Person in Suit Levitating",
  "🧗": "Activity and Sports: Person Climbing",
  "🧗‍♂️": "Activity and Sports: Man Climbing",
  "🧗‍♀️": "Activity and Sports: Woman Climbing",
  "🤺": "Activity and Sports: Person Fencing",
  "🏇": "Activity and Sports: Horse Racing",
  "⛷️": "Activity and Sports: Skier",
  "🏂": "Activity and Sports: Snowboarder",
  "🏌️": "Activity and Sports: Person Golfing",
  "🏌️‍♂️": "Activity and Sports: Man Golfing",
  "🏌️‍♀️": "Activity and Sports: Woman Golfing",
  "🏄": "Activity and Sports: Person Surfing",
  "🏄‍♂️": "Activity and Sports: Man Surfing",
  "🏄‍♀️": "Activity and Sports: Woman Surfing",
  "🚣": "Activity and Sports: Person Rowing Boat",
  "🚣‍♂️": "Activity and Sports: Man Rowing Boat",
  "🚣‍♀️": "Activity and Sports: Woman Rowing Boat",
  "🏊": "Activity and Sports: Person Swimming",
  "🏊‍♂️": "Activity and Sports: Man Swimming",
  "🏊‍♀️": "Activity and Sports: Woman Swimming",
  "⛹️": "Activity and Sports: Person Bouncing Ball",
  "⛹️‍♂️": "Activity and Sports: Man Bouncing Ball",
  "⛹️‍♀️": "Activity and Sports: Woman Bouncing Ball",
  "🏋️": "Activity and Sports: Person Lifting Weights",
  "🏋️‍♂️": "Activity and Sports: Man Lifting Weights",
  "🏋️‍♀️": "Activity and Sports: Woman Lifting Weights",
  "🚴": "Activity and Sports: Person Biking",
  "🚴‍♂️": "Activity and Sports: Man Biking",
  "🚴‍♀️": "Activity and Sports: Woman Biking",
  "🚵": "Activity and Sports: Person Mountain Biking",
  "🚵‍♂️": "Activity and Sports: Man Mountain Biking",
  "🚵‍♀️": "Activity and Sports: Woman Mountain Biking",
  "🤸": "Activity and Sports: Person Cartwheeling",
  "🤹‍♀️": "Activity and Sports: Woman Juggling",
  "🧘": "Activity and Sports: Person in Lotus Position",
  "🧘‍♂️": "Activity and Sports: Man in Lotus Position",
  "🧘‍♀️": "Activity and Sports: Woman in Lotus Position",
  "🎪": "Activity and Sports: Circus Tent",
  "🛹": "Activity and Sports: Skateboard",
  "🛶": "Activity and Sports: Canoe",
  "🎗️": "Activity and Sports: Reminder Ribbon",
  "🎟️": "Activity and Sports: Admission Tickets",
  "🎫": "Activity and Sports: Ticket",
  "🎖️": "Activity and Sports: Military Medal",
  "🏆": "Activity and Sports: Trophy",
  "🧩": "Activity and Sports: Puzzle Piece",
  "♟️": "Activity and Sports: Chess Pawn",
  "🎭": "Activity and Sports: Performing Arts",
  "🎨": "Activity and Sports: Artist Palette",
  "🧵": "Activity and Sports: Thread",
  "🗨️": "Symbols: Left Speech Bubble",
  "🗯️": "Symbols: Right Anger Bubble",
  "💭": "Symbols: Thought Balloon",
  "💤": "Symbols: Zzz",
  "💮": "Symbols: White Flower",
  "♨️": "Symbols: Hot Springs",
  "💈": "Symbols: Barber Pole",
  "🛑": "Symbols: Stop Sign",
  "🕛": "Symbols: Twelve O’Clock"
};

var knownEmoji = Object.keys(emojiDictionary);

export default function App() {
  const [emojiMeaning, setEmojiMeaning] = useState("");

  function emojiInputHandler(event) {
    var userInput = event.target.value;
    var emojiMeaning = emojiDictionary[userInput];

    if (emojiMeaning === undefined) {
      emojiMeaning = "Huh.. Haven't seen that one before.";
    }
    // console.log(emojiMeaning);
    setEmojiMeaning(emojiMeaning);
  }

  function emojiClickHandler(emoji) {
    var emojiMeaning = emojiDictionary[emoji];
    setEmojiMeaning(emojiMeaning);
  }

  return (
    <div className="App">
      <h1 style={{ color: "#1C6DD0" }}> ~Emoji Interpreter~ </h1>

      <input
        placeholder="Search the emoji here or pick one from below. "
        onChange={emojiInputHandler}
      />
      <h2 style={{ color: "#1C6DD0" }}> OUTPUT: {emojiMeaning} </h2>
      <h3 style={{ color: "darkCyan" }}> Emoji's We Know </h3>
      {knownEmoji.map(function (emoji) {
        return (
          <span
            onClick={() => emojiClickHandler(emoji)}
            style={{
              fontSize: "2rem",
              padding: "0.5rem 1rem",
              cursor: "pointer"
            }}
            key={emoji}
          >
            {" "}
            {emoji}{" "}
          </span>
        );
      })}
    </div>
  );
}
